export default __webpack_public_path__ + "static/media/walnut.a5bb9c0c.png";